<template>
  <div id="departments">
    <!-- <div style="height: 6px;"></div>
    <div style="padding: 6px;">
      <span style="font-size:16px;padding-left: 14px;">
        <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
          <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
        </i>
        {{$t('message.title.history')}}
      </span>
    </div> -->

   
    <div style="padding: 10px 20px; height: 5%;">
      <!-- 表格区域 -->
      <vxe-grid ref='xGrid' v-bind="gridOptions" ></vxe-grid>
    </div>
  
  </div>
</template>
<style>

 </style>

<style scoped>
  
</style>

<script>

  import axios from "axios";
  export default {
    data() {
      return {
        gridOptions: {
          keepSource: true,
          resizable: true,
          border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "550",
          size: "small",
          data: [],
          sortConfig: {
            trigger: 'cell'
          },
        },
        gridOptions2: {
          keepSource: true,
          resizable: true,
          border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "300",
          size: "small",
          data: [],
          sortConfig: {
            trigger: 'cell'
          },
        },

        loading: true,
        rols_text: [], //表体显示内容
        get_change_info: "", //父组件传来的值
      }
    },
    mounted() {},

    methods: {
      async getItemHistory() {
        var change_info = this.$store.state.change_info;
        if (this.get_change_info == "") {
          change_info = this.$store.state.change_info;
        } else {
          change_info = this.get_change_info;
        };

        var obj_get = { //获取change
          ... this.$store.state.objectId,
//id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          //subClassId: this.$store.state.subClassId_,
          changeId: change_info.changeId,
          changeClassId: change_info.changeClassId,
          changeSubClassId: change_info.changeSubClassId,
          tableId: 10
        };
        var loadTableUrl = `/pmdm/items/loadTable${this.params(obj_get)}`;
        const { //获取标题
          data: res
        } = await this.$http.get(loadTableUrl);



        let arr = this.getNewTableTitleData(res);
        let newArr  = arr.slice(0);
        newArr.splice(0, 1);
        //this.gridOptions.columns = newArr;
        this.$refs.xGrid.loadColumn(newArr);
        this.rols_text = this.getNewTableContentData(res);
        //this.gridOptions.data = this.rols_text;
         this.$refs.xGrid.loadData(this.rols_text)

      },
    },
    created() {
      this.getItemHistory();
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  
  };
</script>